const React = require('react');
const FormValueUtils = require('hooks/useFormPrimitives/value');
const LifecycleUtils = require('hooks/useFormPrimitives/lifecycle');
const UserInputsConfig = require('./formConstants');

const {
    UI_STATE_FIELDS
} = UserInputsConfig;

const {
    useCallback,
    useEffect,
    useRef,
    useState
} = React;

module.exports = function useUserInputsRendererState({
    formConfig,
    formMethods,
    inputRefs = {},
    props,
    shouldScrollToInterests
}) {

    const [rendererState, setRendererStateValue] = useState(() => formConfig.buildInitialManagedState(props));
    const rendererStateRef = useRef(rendererState);

    useEffect(() => {

        rendererStateRef.current = rendererState;
    }, [rendererState]);

    useEffect(() => {

        if (shouldScrollToInterests) {
            LifecycleUtils.scheduleFocusFieldElement({
                fieldEl: inputRefs.interests?.current,
                scheduler: setTimeout
            });
        }
    }, [inputRefs, shouldScrollToInterests]);

    const setRendererState = useCallback((nextState, callback) => {

        rendererStateRef.current = {
            ...rendererStateRef.current,
            ...nextState
        };

        setRendererStateValue(rendererStateRef.current);

        if (typeof callback === 'function') {
            callback();
        }
    }, []);

    const getFieldValue = useCallback((field) => {

        return FormValueUtils.getFieldValue({
            formMethods,
            state: rendererStateRef.current,
            field
        });
    }, [formMethods]);

    const getRendererStateSlice = useCallback((stateFields) => {

        return FormValueUtils.buildStateSlice({
            state: rendererStateRef.current,
            fields: stateFields
        });
    }, []);

    const getRendererUiState = useCallback(() => {

        return FormValueUtils.buildUiState({
            state: rendererStateRef.current,
            fields: UI_STATE_FIELDS
        });
    }, []);

    return {
        rendererStateRef,
        setRendererState,
        getFieldValue,
        getRendererStateSlice,
        getRendererUiState
    };
};
